import { UserStatus } from "@/types/user-statuses.types";

/**
 * All map coordinates use the floor plan's own units. `y` grows "up" on the plan
 * (north), so it is negated when converted to scene depth.
 */
export type Point = { x: number; y: number };

export enum OfficeView {
    CALL_STATUS = "callStatus",
    SLACK = "slack",
}

export type WallProps = {
    id: string;
    points: Point[];
    // outer: building walls, room: interior partitions, pillar: single-point column
    kind: "outer" | "room" | "pillar";
};

export type LabelProps = {
    id: string;
    x: number;
    y: number;
    text: string;
    fontSize?: number;
    tint?: "primary" | "blue";
};

export type TableProps = {
    id: string;
    x: number;
    y: number;
    size: number; // 1-12 agents
    width: number;
    height: number;
    orientation: "horizontal" | "vertical";
};

export type CableProps = {
    id: string;
    points: Point[];
    color: "green" | "yellow"; // green for network, yellow for electricity
};

export type AgentProps = {
    id: number; // seat number
    x: number;
    y: number;
    assigned: boolean;
    state: UserStatus;
    userId?: string;
};
